export const SEARCH_TARGET_TYPES = [
  "type",
  "constructor",
  "stringConstant",
  "field",
  "method",
  "javaModule",
] as const;

export type SearchTargetType = (typeof SEARCH_TARGET_TYPES)[number];
export const SEARCH_USAGES = ["declaration", "reference"] as const;
export type SearchUsage = (typeof SEARCH_USAGES)[number];

export interface SearchFilters {
  readonly targetTypes: readonly SearchTargetType[];
  readonly usages: readonly SearchUsage[];
}

export interface SearchMatchRange {
  readonly start: number;
  readonly end: number;
}

export interface SearchResult {
  readonly id: number;
  readonly artifactId: string;
  readonly filePath: string;
  readonly symbol: string;
  readonly targetType: SearchTargetType;
  readonly usage: SearchUsage;
  readonly matchRanges: readonly SearchMatchRange[];
}

export interface SearchResponse {
  readonly results: readonly SearchResult[];
  readonly total: number;
}

export type SearchIndexWorkerRequest =
  | {
      readonly type: "index-artifact";
      readonly artifactId: string;
      readonly name: string;
      readonly blob: Blob;
    }
  | {
      readonly type: "remove-artifact";
      readonly artifactId: string;
    }
  | {
      readonly type: "clear";
    }
  | {
      readonly type: "search";
      readonly requestId: number;
      readonly query: string;
      readonly filters: SearchFilters;
    };

export interface SerializedSearchIndexError {
  readonly name: string;
  readonly message: string;
  readonly stack: string | null;
}

export type SearchIndexWorkerResponse =
  | {
      readonly type: "index-state";
      readonly revision: number;
      readonly indexingArtifactCount: number;
      readonly artifactId: string | null;
      readonly state: "started" | "updated" | "completed" | "removed" | "cleared";
    }
  | {
      readonly type: "index-failed";
      readonly revision: number;
      readonly indexingArtifactCount: number;
      readonly artifactId: string;
      readonly error: SerializedSearchIndexError;
    }
  | {
      readonly type: "search-results";
      readonly requestId: number;
      readonly revision: number;
      readonly response: SearchResponse;
    }
  | {
      readonly type: "search-failed";
      readonly requestId: number;
      readonly error: SerializedSearchIndexError;
    };
